<script setup lang="ts">
import { ref, watch } from "vue";
import ValidationErrors from "@/components/Common/ValidationErrors";
import i18n from '@/lang/i18n';

const props = defineProps<{
  salesforceId: string;
  errors: { salesforce_id: string };
  windowInnerWidth: number;
}>();
const emits = defineEmits(["inputValue"]);
const localSalesforceId = ref("");

watch(
  () => props.salesforceId,
  () => {
    localSalesforceId.value = props.salesforceId;
  }
);

watch(localSalesforceId, () => {
  emits("inputValue", localSalesforceId.value);
});
</script>
<template>
  <v-row class="text-form pl-4 pr-3 mb-3">
    <v-col :cols="windowInnerWidth > 800 ? 2 : 3" class="my-auto">
      <h6 class="pl-4">
        {{ i18n.global.t('pages.operationOffices.form.salesforceId') }}
      </h6>
    </v-col>
    <v-col :cols="windowInnerWidth > 800 ? 10 : 9">
      <v-text-field
        v-model="localSalesforceId"
        maxlength="255"
        :error-messages="errors?.salesforce_id"
      />
    </v-col>
  </v-row>
</template>
